module.exports = __webpack_public_path__ + "static/media/jpeg.bbc1878b.svg";